import { FC } from 'react';
import classNames from 'classnames';

import { SwimlaneItem } from '@rikstv/play-common/src/forces/assetDetails/assetDetails.types';
import { getImagePackSet } from '@rikstv/play-common/src/utils/imagePack/imagePack.utils';
import { H3 } from '@rikstv/shared-components';

import { AssetImage } from '../../assetImage/AssetImage';
import { Breakpoints } from '../../grid/breakpoints';
import { SwimlaneItemImageOverlay } from '../../imageOverlays';
import { ProviderImageWrapper } from '../../providerImage/ProviderImageWrapper';
import { getLinkTo } from '../swimlane.utils';
import { useSwimlaneItemAriaLabel } from '../useSwimlaneItemAriaLabel';

import { ItemWrapper } from './ItemWrapper';
import { AgeLimitPill } from './StandardItem';

import styles from './SuperWideItem.module.css';

interface Props {
  item: SwimlaneItem;
  preventNavigation?: boolean;
  onClick?: () => void;
}

export const SuperWideItem: FC<Props> = ({ item, preventNavigation, onClick }) => {
  const image = item.image;
  /* the title is part of the artwork here, so there is no subtitle element to announce */
  const ariaLabel = useSwimlaneItemAriaLabel(item, { showSubtitle: false, showImdbRating: 'never' });

  return (
    <ItemWrapper
      className={classNames(styles.asset, 'with-keyboard-focus')}
      ariaLabel={ariaLabel}
      preventDefault={preventNavigation}
      linkTo={getLinkTo(item)}
      onClick={onClick}>
      <H3 className="sr-only"> {item.title} </H3>
      <div className={styles.imageContainer}>
        <AssetImage
          ratio="32_9"
          imageSet={getImagePackSet({
            url: item.image.url,
            variations: [
              { height: 600, breakpoint: Breakpoints.XL },
              { height: 400, breakpoint: Breakpoints.SM },
              { height: 230, breakpoint: Breakpoints.DEFAULT },
            ],
          })}
          alt={item.title}
          blackWhite={image.bwFilter}
        />
        <SwimlaneItemImageOverlay programState={item.programState} />
        <ProviderImageWrapper logos={item.logos} width={'max(4%, var(--rds-spacing--32))'} />
        <AgeLimitPill ageLimit={item.ageLimit} />
      </div>
    </ItemWrapper>
  );
};
